"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function getStarType(target, rating) {
  var diff = rating - target;
  if (diff < 0.25) return 'empty';
  if (diff > 0.75) return 'full';
  return 'halfFull';
}
var _default = getStarType;
exports["default"] = _default;
//# sourceMappingURL=getStarType.js.map